import { State } from '../../reducers/rootReducer'
import LastConfigurationAvailability from '../../../entities/LastConfigurationAvailability'

const lastConfigurationsAvailabilitiesSelector = (state: State): LastConfigurationAvailability[] =>
    state.lastConfigurationsInfo?.lastConfigurationsAvailabilities ?? []

export default lastConfigurationsAvailabilitiesSelector
